export const CREDENTIAL_QUESTION_TYPES = {
	SELECT: 'select',
	NUMBER: 'number',
	DATE_PICKER: 'date_picker',
	MULTIPLE_SELECT: 'multi_select',
	TEXT: 'text',
}

export const CREDENTIAL_QUESTION_NAME = {
	LOCATION: 'Locations',
	ISSUING_AUTHORITY: 'Issuing Authority',
	DATE_CERTIFIED: 'Date Certified',
	EXPIRATION_DATE: 'Expiration Date',
	LICENSE_NUMBER: 'License Number',
	LICENSE_TYPE: 'License Type',
	CERTIFICATION_NUMBER: 'Certification Number',
	CERTIFICATION_TYPE: 'Certification Type',
}

export const CHECK_LIST_PROFILE_TRACKING_EVENT = {
	SCREEN_TRACKING: 'profile-management-skill-check-lists',
	SCREEN_POPUP_TRACKING: 'confirm-open-una-linke',
	CLICK_OPEN_UNA_LINK_BTN: 'open-una-link_btn_profile-management-skill-check-lists',
}

export const ADDITION_SKILL_CHECKLIST_STATUS = {
	completed: 'completed',
	assigned: 'assigned',
	notAssigned: 'not_assigned',
}

export const SKILL_CHECKLIST_TRACKING_EVENT = {
	SCREEN_TRACKING: 'profile-completion-skill-check-lists',
	SCREEN_POPUP_TRACKING: 'confirm-open-una-link',
	CLICK_SKIP_STEP_5: 'skip-step-5_link',
	CLICK_OPEN_UNA_LINK_BTN: 'open-una-link_btn',
	CLICK_PREVIOUS_BTN: 'previous-step_btn',
	CLICK_NEXT_STEP_BTN: 'next-step_btn',
	CLICK_CANCEL_BTN: 'cancel_btn',
	CLICK_CONFIRM_BTN: 'confirm_btn',
}
